import { Box, Text, VStack, Divider } from '@chakra-ui/react';

import type { CoverageSectionProps } from './types';
import EnvironmentalCoveragesSection from './EnvironmentalCoveragesSection';
import HouseholdCoveragesSection from './HouseholdCoveragesSection';
import SolarPanelSection from './SolarPanelSection';
import IncludedPerilAdjustmentsSection from './IncludedPerilAdjustmentsSection';

const AdditionalCoveragesSection = ({
  coverages,
  updateCoverage,
  isLoadingCodes,
}: CoverageSectionProps) => {
  return (
    <Box>
      <Text fontWeight="700" fontSize="lg" mb={4}>
        Additional Coverages
      </Text>
      <VStack spacing={4} align="stretch">
        <EnvironmentalCoveragesSection
          coverages={coverages}
          updateCoverage={updateCoverage}
          isLoadingCodes={isLoadingCodes}
        />

        <Divider />

        <HouseholdCoveragesSection
          coverages={coverages}
          updateCoverage={updateCoverage}
        />

        <Divider />

        <SolarPanelSection
          coverages={coverages}
          updateCoverage={updateCoverage}
          isLoadingCodes={isLoadingCodes}
        />

        <Divider />

        <IncludedPerilAdjustmentsSection
          coverages={coverages}
          updateCoverage={updateCoverage}
        />
      </VStack>
    </Box>
  );
};

export default AdditionalCoveragesSection;
